import { api } from "@/frontend/services/api";
import type {
  UpdateDisciplineRequestDTO,
  DisciplineResponseDTO,
  DisciplinesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/disciplines/private";

export const disciplineService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<DisciplinesPaginatedResponseDTO>>(
      BASE_URL,
      params
    );
  },
  getById: (id?: string) =>
    api.get<ApiResponse<DisciplineResponseDTO>>(`${BASE_URL}/${id}`),
  update: (id: string, data: UpdateDisciplineRequestDTO) =>
    api.put<ApiResponse<DisciplineResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
